import { useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DOC_KINDS, download } from "@/admin/hr/common";

export const docUrl = (appId, d) => `/admin/hr/applications/${appId}/documents/${d.id}`;

function useBlobUrl(appId, doc) {
  const [state, setState] = useState({ src: null, err: false });
  useEffect(() => {
    let url;
    if (!doc) return undefined;
    setState({ src: null, err: false });
    api.get(docUrl(appId, doc), { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setState({ src: url, err: false }); })
      .catch(() => setState({ src: null, err: true }));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [appId, doc]);
  return state;
}

function Preview({ src, doc }) {
  if (doc.content_type?.startsWith("image/")) return <img src={src} alt={DOC_KINDS[doc.kind]} className="mx-auto max-h-[70vh] rounded border" data-testid="doc-viewer-image" />;
  if (doc.content_type === "application/pdf") return <iframe title="Belge" src={src} className="h-[70vh] w-full rounded border" data-testid="doc-viewer-pdf" />;
  return <p className="text-sm text-zinc-600">Bu dosya türü tarayıcıda önizlenemiyor; indirerek açabilirsiniz.</p>;
}

function Body({ appId, doc }) {
  const { src, err } = useBlobUrl(appId, doc);
  if (err) return <p className="text-sm text-red-600">Belge yüklenemedi.</p>;
  if (!src) return <Loader2 className="mx-auto h-6 w-6 animate-spin text-[color:var(--red)]" />;
  return <Preview src={src} doc={doc} />;
}

export function DocViewer({ appId, doc, onClose }) {
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-4xl overflow-y-auto" data-testid="doc-viewer">
        <DialogHeader><DialogTitle>{doc ? DOC_KINDS[doc.kind] || "Belge" : ""}</DialogTitle></DialogHeader>
        {doc && <Body appId={appId} doc={doc} />}
        {doc && (
          <button onClick={() => download(docUrl(appId, doc), doc.filename, { params: { download: 1 } })} className="btn-red !py-2" data-testid="doc-viewer-download"><Download className="h-4 w-4" /> İndir</button>
        )}
      </DialogContent>
    </Dialog>
  );
}
